import { useCallback, useRef } from "react";


const useDebouncedCallback = <T extends CallableFunction>(func:T, debounceMs: number) => {
    const timeout = useRef<NodeJS.Timeout | null>(null)
  
    return useCallback((...args: unknown[]) => {
        const later = () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
                timeout.current = null
            }
            func(...args);
        }
  
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
        timeout.current = setTimeout(later, debounceMs);
      }, [func, debounceMs])
  }

  export default useDebouncedCallback